export const ALERT_DRAWER_HEADING = 'Notifications';

export const NO_ENTRIES_TEXT = 'There are currently no notifications!';
export const CLOSE = 'Close';

// Tab identifiers / labels for the notifications drawer
export const TAB_GLOBAL = 'global';
export const TAB_POINTS = 'points';
export const TAB_GLOBAL_LABEL = 'Global';
export const TAB_POINTS_LABEL = 'No Clear Image';

// Alert type that flags a points entry whose photo captured no clear subject
export const POINT_NO_CLEAR_SUBJECT = 'POINT_NO_CLEAR_SUBJECT';

export const NO_GLOBAL_ENTRIES_TEXT =
  'There are currently no global notifications!';
export const NO_POINTS_ENTRIES_TEXT =
  'There are no points entries with unclear images!';
